import moment from 'moment'
import { API } from '@/models/core'

export class CricketChatUser {
  get shouldRegister () {
    return this.require_registration === true
  }

  updateUserStatus (chatUser) {
    this.require_registration = chatUser.require_registration
    this.chat_userkey = chatUser.chat_userkey
  }

  register () {
    const utcOffset = moment().utcOffset() * 60
    const postData = {
      name: this.user.name,
      email: this.user.email,
      gender: this.user.gender,
      utcOffset
    }

    return API.instance().post('/cricket/chatbot/register/', postData).then((resp) => {
      const raw = resp.data.data
      const user = CricketChatUser.createFromJson(raw)
      return user
    })
  }

  answer (text) {
    const utcOffset = moment().utcOffset() * 60
    const postData = {
      chatUserKey: this.chat_userkey,
      text,
      utcOffset
    }

    return API.instance().post('/cricket/chatbot/answer/', postData).then((resp) => {
      const responses = resp.data.data.data.responses
      let messages = []

      responses.forEach((raw) => {
        const msg = ChatMessage.createFromJson(raw, true)
        messages.push(msg)
      })

      return messages
    })
  }

  deleteUser () {
    return API.instance().post('/cricket/chatbot/delete-user/').then((resp) => {
      const raw = resp.data.data
      const user = CricketChatUser.createFromJson(raw)
      return user
    })
  }

  static getStart () {
    return API.instance().get('/cricket/chatbot/get-start/').then((resp) => {
      const raw = resp.data.data
      const user = CricketChatUser.createFromJson(raw)
      return user
    })
  }

  static createFromJson (raw) {
    let user = new CricketChatUser()
    user = Object.assign(user, raw)
    if (user.user) {
      if (!user.user.gender) {
        user.user.gender = 'male'
      }
    }
    return user
  }
}

CricketChatUser.State = {
  user: null
}

export class ChatMessage {
  constructor (message, isBot, isUser, data) {
    this.message = message
    this.isBot = isBot || false
    this.isUser = isUser || false
    this.data = data || {}
    this.handler = null
    this.responder = null
    this.confident = 0
    this.userShouldRespond = false
  }

  static buildWelcome (user) {
    const message = `Hello ${user.name}, How can i help you?`
    return new ChatMessage(message, true)
  }

  static createFromJson (raw, isBot) {
    let msg = new ChatMessage(raw.content, isBot, !isBot, raw.objects)
    msg.handler = raw.handler
    msg.responder = raw.responder
    msg.confident = raw.confident
    msg.userShouldRespond = raw.user_should_respond
    return msg
  }
}

ChatMessage.State = {
  messages: []
}
